<template>
  <div>
    <ul v-if="type=='pill'" class="tabs flex flex-wrap bg-gray-300 p-2 rounded">
      <li v-for="(tab, index) in tabs" :key="index" :class="{'is-active': tab.isActive, 'flex-1': true, 'mr-2': true}">
        <a @click="selectTab(tab)" :class="tab.isActive ? activeTabClass : tabClass">
            <span v-html="tab.name"></span>
            <template v-if="tab.tags.length > 0">
              <span class="tag"  v-for="(tag, index) in tab.tags" :key="index" :style="[tag.color ? {backgroundColor: tag.color} : '']">{{ tag.content }}</span>
            </template>
        </a>
      </li>
    </ul>
    <ul v-else-if="type==='button'" class="flex items-center justify-center text-sm sm:text-base">
      <li v-for="(tab, index) in tabs" :key="index" :class="{'is-active': tab.isActive}">
        <a @click="selectTab(tab)" :class="tab.isActive ? buttonActiveClass : buttonClass">
          <span v-html="tab.name"></span>
          <template v-if="tab.tags.length > 0">
            <span class="tag"  v-for="(tag, index) in tab.tags" :key="index" :style="[tag.color ? {backgroundColor: tag.color} : '']">{{ tag.content }}</span>
          </template>
        </a>
      </li>
    </ul>
    <ol v-else-if="type==='steps'" role="list" class="divide-y divide-gray-300 rounded-md border border-gray-300 md:flex md:divide-y-0 bg-white">
      <li v-for="(tab, index) in tabs" :key="index" class="relative md:flex md:flex-1">
        <!-- Completed Step -->
        <a @click="selectTab(tab)" v-if="currentIndex > index" class="group flex w-full items-center cursor-pointer">
          <span class="flex items-center px-6 py-2 md:py-4 text-sm font-medium">
            <span class="flex h-8 w-8 md:h-10 md:w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-600 group-hover:bg-blue-800">
              <!-- Heroicon name: solid/check -->
              <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clip-rule="evenodd" />
              </svg>
            </span>
            <span class="ml-4 text-sm font-medium text-gray-900">{{ tab.name }}</span>
          </span>
        </a>

        <a v-else-if="currentIndex === index" class="flex items-center px-6 py-2 md:py-4 text-sm font-medium" aria-current="step">
          <span class="flex h-8 w-8 md:h-10 md:w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-blue-600">
            <span class="text-blue-600">{{ index + 1 }}</span>
          </span>
          <span class="ml-4 text-sm font-medium text-blue-600">{{ tab.name }}</span>
        </a>

        <a @click="selectTab(tab)" v-else class="group flex items-center cursor-pointer">
          <span class="flex items-center px-6 py-2 md:py-4 text-sm font-medium">
            <span class="flex h-8 w-8 md:h-10 md:w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-gray-300 group-hover:border-gray-400">
              <span class="text-gray-500 group-hover:text-gray-900">{{ index + 1 }}</span>
            </span>
            <span class="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900">{{ tab.name }}</span>
          </span>
        </a>

        <template v-if="index !== tabs.length - 1">
          <!-- Arrow separator for lg screens and up -->
          <div class="absolute top-0 right-0 hidden h-full w-5 md:block" aria-hidden="true">
            <svg class="h-full w-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
              <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round" />
            </svg>
          </div>
        </template>
    </li>
    </ol>
    <ul v-else class="justify-start flex flex-wrap bg-gray-300 pt-4 px-2 rounded">
      <li v-for="(tab, index) in tabs" :key="index" :class="{'is-active': tab.isActive}">
        <a @click="selectTab(tab)" :class="tab.isActive ? classicActiveClasss : classicClass">
          <span v-html="tab.name"></span>
          <template v-if="tab.tags.length > 0">
            <span class="tag"  v-for="(tag, index) in tab.tags" :key="index" :style="[tag.color ? {backgroundColor: tag.color} : '']">{{ tag.content }}</span>
          </template>
        </a>
      </li>
    </ul>
    <div class="tabs-details">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  props: {
    type: {
      type: String,
      default: 'pill'
    }
  },
  data () {
    return {
      tabs: [],
      activeTabClass: [
        'text-center',
        'block',
        'rounded',
        'border',
        'border-blue-500',
        'bg-blue-500',
        'hover:bg-blue-600',
        'text-white',
        'hover:text-white',
        'py-2',
        'px-4',
        'no-underline',
        'hover:no-underline'

      ],
      tabClass: [
        'text-center',
        'block',
        'rounded',
        'text-black',
        'hover:bg-white',
        'hover:text-blue-600',
        'py-2',
        'px-4',
        'no-underline',
        'hover:no-underline'

      ],
      classicActiveClasss: [
        'bg-white',
        'inline-block',
        'border-l',
        'border-t',
        'border-r',
        'rounded-t-lg',
        'py-2',
        'px-4',
        'text-blue-700',
        'font-semibold',
        'hover:no-underline'
      ],
      classicClass: [
        'bg-transparent',
        'inline-block',
        'py-2',
        'px-4',
        'text-blue-500',
        'font-semibold',
        'hover:text-blue-800',
        'hover:no-underline'
      ],
      buttonActiveClass: [
        'py-2',
        'px-2',
        'sm:px-5',
        'bg-blue-500',
        'text-white',
        'border',
        'border-blue-500'
      ],
      buttonClass: [
        'py-2',
        'px-2',
        'sm:px-5',
        'border-blue-500',
        'hover:bg-blue-300',
        'hover:border-blue-300',
        'hover:text-white',
        'border'
      ]
    }
  },
  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach(tab => {
        if (tab.name === selectedTab.name) {
          tab.isActive = true // (tab.name === selectedTab.name)
          this.$emit('selectedTab', tab.name)
        } else {
          tab.isActive = false
        }
      })
    },
    setTab (index) {
      this.selectTab(this.tabs[index])
    }
  },
  created () {
    this.tabs = this.$children
  },
  computed: {
    currentIndex () {
      let index = 0
      this.tabs.forEach((t, i) => {
        if (t.isActive) {
          index = i
        }
      })
      return index
    }
  }
}
</script>
